import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import newsSection from './sections/news';

/** boilerplate specific sections */
init();
modalSection();
headerSection();
newsSection();

/** additional scripts */
// ...


// WEBPACK FOOTER //
// ./source/scripts/main.js